/**
 * Bandeau de statistiques par nature de machine — cliquable : chaque
 * pastille est aussi un filtre, pas seulement un décompte.
 */
export interface StatNature {
  readonly assetType: string;
  readonly count: number;
}

export function StatsNature({
  byNature,
  valeur,
  onChange,
}: {
  byNature: readonly StatNature[];
  valeur: string | null;
  onChange: (assetType: string | null) => void;
}) {
  if (byNature.length === 0) return null;

  const total = byNature.reduce((s, n) => s + n.count, 0);

  return (
    <div className="stats-nature">
      <button
        type="button"
        className={`stat-nature${valeur === null ? ' actif' : ''}`}
        onClick={() => onChange(null)}
      >
        <strong>{total}</strong>
        <span>Toutes natures</span>
      </button>
      {byNature.map((n) => (
        <button
          key={n.assetType}
          type="button"
          className={`stat-nature${valeur === n.assetType ? ' actif' : ''}`}
          onClick={() => onChange(valeur === n.assetType ? null : n.assetType)}
        >
          <strong>{n.count}</strong>
          <span>{n.assetType}</span>
        </button>
      ))}
    </div>
  );
}
